import React, { useLayoutEffect, useState } from "react";
import { Route as ReactDOMRoute, Redirect } from "react-router-dom";
import AuthLoading from "../components/AuthLoading/AuthLoading";
import { checkAuthentication, hasSessionUser } from "../api/firebaseFunctions";

const Route = ({ requiresAuth = false, component: Component }) => {
    const [loading, setLoading] = useState(false);

    useLayoutEffect(() => {
        if (!hasSessionUser()) {
            setLoading(true);
            checkAuthentication().then(() => setLoading(false));
        }
    }, [])

    const renderComponent = ({ location }) => {
        if (loading) {
            return <AuthLoading />;
        }

        if (requiresAuth && !hasSessionUser()) {
            return (
                <Redirect to={{ pathname: "/", state: { from: location } }} />
            );
        } else if (!requiresAuth && hasSessionUser()) {
            return (
                <Redirect
                    to={{ pathname: "/dashboard", state: { from: location } }}
                />
            );
        }

        return <Component />;
    };

    return <ReactDOMRoute render={renderComponent} />;
};

export default Route;
